export interface TermsSection {
  title: string;
  items: string[];
}

export const TERMS_SECTIONS: TermsSection[] = [
  {
    title: '1. מבוא והגדרות',
    items: [
      'המבוא להסכם זה מהווה חלק בלתי נפרד ממנו.',
      'הסכם זה מסדיר את תנאי השימוש, ההתקשרות, הרישוי, הגישה, התשלום, החידוש, הביטול והשימוש במערכת Closer, לרבות כל תוכנה, ממשק, שירות, פלטפורמה, תוסף, אתר, לוח ניהול, שירותי תמיכה, שירותים נלווים, תכנים, עדכונים, שדרוגים וכל רכיב אחר המסופק על ידי החברה.',
      'הסכם זה חל על כל אדם, תאגיד, עסק, משתמש או לקוח אשר שילם עבור המערכת ו/או קיבל גישה אליה ו/או התקין אותה ו/או התחבר אליה ו/או השתמש בה ו/או ביקש להשתמש בה, במישרין או בעקיפין.',
      'אם המשתמש פועל בשם חברה, עסק, שותפות או כל גוף אחר, הוא מצהיר כי הוא מוסמך להתחייב בשם אותו גוף, וכי אותו גוף יהיה מחויב בכל הוראות הסכם זה.',
      'הסכם זה מהווה הסכם מחייב בין הלקוח לבין החברה, והוא יחול ויגבר על כל מסמך מסחרי, הצעת מחיר, הזמנה, חשבונית, קבלה, דוא"ל, הודעת מערכת או מסמך נלווה אחר.',
      '"החברה" / "הספק" – סנדל ישראל בע"מ, לרבות מי מטעמה, עובדיה, מנהליה, נציגיה, קבלני המשנה שלה וכל גוף קשור הפועל מטעמה.',
      '"המערכת" – מערכת AI המסייעת לנציגי מכירות בזמן אמת, לרבות האזנה, ניתוח חי, זיהוי תוכן שיחה, תמלול, הצגת טיפים, הכוונה במהלך השיחה, סיכום שיחה אוטומטי.',
      '"הלקוח" – הלקוח ו/או כל אדם הפועל מטעמו, לרבות עובדיו, נציגיו, משתמשיו, ספקיו, מי מטעמו.',
      '"המשתמש" – כל מי שעושה שימוש בפועל במערכת מטעם הלקוח.',
      '"התמורה" – כל סכום שעל הלקוח לשלם לחברה לפי הסכם זה, לרבות דמי מנוי, תשלומי טוקנים, מסים, מע"מ.',
      '"תקופת ההתחייבות" – התקופה הקבועה של המסלול שנבחר על ידי הלקוח.',
      '"יום התחלת השירות" – יום ביצוע התשלום על ידי הלקוח.',
      '"טוקנים" – יחידות צריכה, עיבוד, שימוש, הפעלה, חישוב, שליחת בקשות, יצירת פלטים.',
      '"מנוי מתחדש" – מנוי אשר מתחדש אוטומטית בתום כל תקופת מנוי נוספת.',
      'מובהר כי יום התחלת השירות אינו תלוי בשימוש בפועל של הלקוח במערכת.',
      'פרטי הגישה למערכת נשלחים ללקוח עם ביצוע התשלום, וממועד זה השירות ייחשב כזמין עבורו.',
      'הלקוח אחראי הבלעדי לעשות שימוש במערכת בפועל לאחר קבלת הגישה אליה.',
      'הלקוח מצהיר כי הוא מתקשר עם החברה לצורך פעילותו העסקית ו/או המקצועית.',
    ],
  },
  {
    title: '2. אישור ההסכם וההתקשרות',
    items: [
      'ביצוע תשלום עבור המערכת, בצירוף משלוח הסכם זה לכתובת הדוא"ל שמסר הלקוח, והעמדת השירות ו/או פרטי הגישה לרשות הלקוח, יהוו אישור, הסכמה והתחייבות מלאה ומחייבת לכל תנאי הסכם זה.',
      'הלקוח מצהיר ומאשר כי ביצוע התשלום עבור השירות יהוו ראיה מספקת לכך שהלקוח קיבל את ההסכם, עיין בו, אישר אותו והסכים לכל תנאיו.',
      'מובהר כי ההסכם יחייב את הלקוח גם אם לא חתם עליו בחתימה ידנית או דיגיטלית.',
      'הלקוח מוותר על כל טענה שלפיה לא קרא את ההסכם, לא הבין אותו, לא אישר אותו בלחיצה אקטיבית.',
      'רישומי החברה, מערכות הדיוור, מערכות החיוב, לוגים טכנולוגיים, נתוני התקנה, נתוני התחברות — יהוו ראיה לכאורה לכל עניין הנוגע לשליחת ההסכם.',
    ],
  },
  {
    title: '3. השירות המוענק ללקוח',
    items: [
      'הספק יעניק ללקוח גישה למערכת הכוללת: האזנה לשיחות בזמן אמת; זיהוי תוכן שיחה בזמן אמת; מתן טיפים, רעיונות והצעות בזמן אמת; סיכום שיחה אוטומטי.',
      'המערכת הינה מערכת עזר בלבד ללקוח. עלולים ליפול בה שיבושים, והלקוח הוא היחיד שאחראי לדברים שנאמרים בשיחה.',
      'כל מידע או המלצה שהמערכת מציגה הוא בגדר הצעה בלבד, והאחריות הסופית על אופן ההתנהלות בשיחה חלה על הלקוח בלבד.',
      "הספק רשאי, בכל עת ועל פי שיקול דעתו הבלעדי, לעדכן, לשנות, להסיר, להשהות או להוסיף פיצ'רים, יכולות, מודולים, ממשקים, שירותים, מודלים, ספקים, פרמטרים או כל מרכיב אחר של המערכת.",
      'הספק אינו מתחייב על זמינות רציפה, ועשויים להתרחש הפסקות שירות מתוכננות ולא מתוכננות.',
    ],
  },
  {
    title: '4. אחריות מקצועית ושיקול דעת הלקוח',
    items: [
      'הלקוח הוא האחראי הבלעדי לתוכן הדברים הנאמרים במהלך השיחה.',
      'הלקוח יפעיל שיקול דעת עצמאי ולא יסתמך באופן עיוור על המלצות המערכת.',
      'ככל שהמערכת מציגה טיפ, רעיון או הצעה שאינה מתאימה לנסיבות — אחריות הלקוח שלא לאמץ אותה ולפעול בהתאם לשיקול דעתו המקצועי.',
      'הספק לא יישא בכל אחריות לתוצאות עסקיות, אמירות, פעולות או החלטות של הלקוח.',
      'האחריות המלאה להתנהלות בשיחה, לתוכן הדברים ולפעולות הננקטות בה — חלה על הלקוח בלבד.',
      'המערכת הינה כלי טכנולוגי המספק המלצות בינה מלאכותית, ומטבעה עלולים להיווצר אי דיוקים, טעויות או חוסר התאמה לנסיבות.',
    ],
  },
  {
    title: '5. חוקיות האזנה ועמידה בדין',
    items: [
      'הלקוח אחראי לוודא כי השימוש במערכת — לרבות האזנה ועיבוד שיחות בזמן אמת — עומד בדרישות הדין החל עליו, ושהוא צד בשיחה שהמערכת פועלת בה.',
      'הספק אינו מספק ייעוץ משפטי לגבי היבטי חוקיות, פרטיות או הקלטה, והאחריות לבחינתם מוטלת על הלקוח בלבד.',
      'כל טענה מצד שלישי בנוגע להפרת פרטיות או הקלטה אסורה — באחריות הלקוח בלבד.',
      'הספק אינו אחראי לכל טענה של צד שלישי הנוגעת לפרטיות או הקלטה.',
    ],
  },
  {
    title: '6. מסירה ואחסון מידע אצל ספקי משנה',
    items: [
      "הספק רשאי להשתמש בספקי משנה ככל שיבחר ללא כל הגבלה שהיא (ענן, אחסון, תמלול, בינה מלאכותית, אבטחה וכו').",
      'הלקוח מאשר מראש מסירה ואחסון אלה.',
      'המידע עשוי להישלח לשרתי עיבוד מחוץ לישראל בהתאם לתפעול טכנולוגיות AI וטכנולוגיות נוספות לצורך הפעלת המערכת.',
    ],
  },
  {
    title: '7. אבטחת מידע',
    items: [
      'הספק מפעיל אמצעי אבטחה סבירים, לרבות סיסמאות ובקרות גישה.',
      'הספק לא יהיה אחראי לאירועי תקיפה, פריצה או אובדן מידע.',
      'הלקוח מאשר כי אין באפשרות הספק להבטיח אבטחה מוחלטת מפני פריצות, תקיפות סייבר, חשיפות מידע או כשלים טכנולוגיים.',
    ],
  },
  {
    title: '8. סודיות מלאה ואי-גילוי',
    items: [
      'הלקוח מתחייב לשמור בסודיות מלאה כל מידע טכנולוגי, עסקי או מקצועי של הספק הנוגע למערכת.',
      'על אף האמור, ללקוח מותר לשתף פלטים, תשובות, תוצרים ותוכן שנוצרו עבורו על ידי המערכת, לרבות צילומי מסך של התוצרים בלבד.',
      'אסור לבצע הנדסה לאחור או כל ניסיון ללמוד את מנגנוני המערכת.',
      'חובת הסודיות אינה מוגבלת בזמן.',
      'כל הפרה של סעיף זה תיחשב כהפרה יסודית של ההסכם.',
    ],
  },
  {
    title: '9. תשלום ומחירים',
    items: [
      'עלות חודשית קבועה לכל משתמש: 300 ש"ח + מע"מ.',
      'בנוסף, הלקוח ישלם עבור שימוש בטוקנים להפעלת מערכות הבינה המלאכותית בהתאם לצריכתו בפועל. תשלום הטוקנים יתבצע לפי הצריכה בפועל כל $20 לכל משתמש. יש לטעון תשלום טוקנים מראש.',
      'אין החזרים חלקיים.',
      'כל צד רשאי לסיים את ההתקשרות בכל עת בהודעה בכתב.',
      'חיוב העלות החודשית יעצר בסוף מחזור החיוב הנוכחי.',
    ],
  },
  {
    title: '10. הגבלת אחריות ושיפוי',
    items: [
      'אחריות הספק מוגבלת לגובה התשלום החודשי הקבוע האחרון בלבד.',
      'לא תהיה לספק אחריות לנזקי רווחים, אובדן מכירות, טעויות AI, חוסר דיוק, באגים במערכת המונעים שימוש באופן זמני, שיבושים או כל תוצאה עסקית.',
      'המערכת אינה מבטיחה תוצאות או הצלחה כלשהי.',
      'הלקוח ישפה את הספק בגין כל נזק או תביעה הנובעים מהפרת דין, שימוש אסור או הסתמכות שגויה על המערכת.',
    ],
  },
  {
    title: '11. שימוש במידע',
    items: [
      'הלקוח מודע ומסכים לכך שהפעלת המערכת כרוכה בשימוש במידע ובנתונים שונים, וכי החברה רשאית להשתמש במידע זה במסגרת פעילותה השוטפת, לצורך מתן השירותים ושיפורם.',
      'הספק מתחייב כי לא ייצור קשר יזום עם הלידים או הלקוחות של הלקוח, ולא יפנה אליהם לצורך הצעה, שיווק או מכירה של שירותים מתחרים.',
      'התחייבות זו אינה חלה על שימוש במידע סטטיסטי, אנונימי או מצרפי.',
    ],
  },
  {
    title: '12. הודעות, דין ושיפוט',
    items: [
      'הודעות יישלחו בדוא"ל וייחשבו כנמסרו תוך 24 שעות.',
      'ההסכם כפוף לדין הישראלי.',
      'סמכות השיפוט: בתי המשפט במחוז תל אביב.',
      'שינויים בהסכם ייכנסו לתוקף עם פרסומם באתר החברה ו/או משלוח הודעה ללקוח.',
      'ויתור חד-פעמי על זכות אינו ויתור כללי.',
      'אם סעיף כלשהו יימצא בלתי אכיף, יתר הסעיפים יישארו בתוקף.',
      'הסכם זה ממצה את כלל ההבנות בין הצדדים בכל הנוגע לנושא ההתקשרות.',
      'כותרות הסעיפים נועדו לנוחות בלבד ולא ישמשו לצורך פרשנות.',
    ],
  },
];

/**
 * Terms of Service content - Based on terms.txt, excluding Installation section (Section 3)
 */
export const TERMS_CONTENT = `הסכם שימוש ותנאי התקשרות – Closer

בין: סנדל ישראל בע"מ, ח.פ. 514628403 (להלן: "החברה" ו/או "הספק")
לבין: המשתמש שמאשר הסכם זה, במישרין או בעקיפין (להלן: "הלקוח")
 
1. מבוא והגדרות
1.1
המבוא להסכם זה מהווה חלק בלתי נפרד ממנו.
1.2
הסכם זה מסדיר את תנאי השימוש, ההתקשרות, הרישוי, הגישה, התשלום, החידוש, הביטול והשימוש במערכת Closer, לרבות כל תוכנה, ממשק, שירות, פלטפורמה, תוסף, אתר, לוח ניהול, שירותי תמיכה, שירותים נלווים, תכנים, עדכונים, שדרוגים וכל רכיב אחר המסופק על ידי החברה.
1.3
הסכם זה חל על כל אדם, תאגיד, עסק, משתמש או לקוח אשר שילם עבור המערכת ו/או קיבל גישה אליה ו/או התקין אותה ו/או התחבר אליה ו/או השתמש בה ו/או ביקש להשתמש בה, במישרין או בעקיפין.
1.4
אם המשתמש פועל בשם חברה, עסק, שותפות או כל גוף אחר, הוא מצהיר כי הוא מוסמך להתחייב בשם אותו גוף, וכי אותו גוף יהיה מחויב בכל הוראות הסכם זה.
1.5
הסכם זה מהווה הסכם מחייב בין הלקוח לבין החברה, והוא יחול ויגבר על כל מסמך מסחרי, הצעת מחיר, הזמנה, חשבונית, קבלה, דוא"ל, הודעת מערכת או מסמך נלווה אחר, אלא אם החברה אישרה אחרת בכתב ובמפורש.
1.6
"החברה" / "הספק" – סנדל ישראל בע"מ, לרבות מי מטעמה, עובדיה, מנהליה, נציגיה, קבלני המשנה שלה וכל גוף קשור הפועל מטעמה לצורך אספקת השירות.
1.7
"המערכת" – מערכת AI המסייעת לנציגי מכירות בזמן אמת, לרבות האזנה, ניתוח חי, זיהוי תוכן שיחה, תמלול, הצגת טיפים, הכוונה במהלך השיחה, סיכום שיחה אוטומטי, וכן כל רכיב, מודול, ממשק, עמוד, API, שירות ענן, תוכנה נלווית, דשבורד, עדכון, גרסה, תיעוד, פיצ'ר, כלי, שירות או יכולת הקשורים אליה.
1.8
"הלקוח" – הלקוח ו/או כל אדם הפועל מטעמו, לרבות עובדיו, נציגיו, משתמשיו, ספקיו, מי מטעמו או כל גורם אחר אשר רכש, שילם, קיבל גישה, התקין, התחבר, השתמש או ביקש להשתמש במערכת.
1.9
"המשתמש" – כל מי שעושה שימוש בפועל במערכת מטעם הלקוח או מטעמו.
1.10
"התמורה" – כל סכום שעל הלקוח לשלם לחברה לפי הסכם זה, לרבות דמי מנוי, תשלומי טוקנים, מסים, מע"מ, ריבית פיגורים, הוצאות גבייה, חיובים נלווים וכל סכום אחר המגיע לחברה.
1.11
"תקופת ההתחייבות" – התקופה הקבועה של המסלול שנבחר על ידי הלקוח, וכן כל תקופת חידוש נוספת של אותו מסלול, ככל שחודשה בהתאם להסכם זה.
1.12
"יום התחלת השירות" – יום ביצוע התשלום על ידי הלקוח.
1.13
"טוקנים" – יחידות צריכה, עיבוד, שימוש, הפעלה, חישוב, שליחת בקשות, יצירת פלטים, חיבורי API או כל יחידת שימוש אחרת במערכת, כפי שתוגדר, תימדד ותחושב על ידי החברה ו/או ספקי השירות הרלוונטיים מעת לעת על פי שיקול דעת החברה.
1.14
"מנוי מתחדש" – מנוי אשר מתחדש אוטומטית בתום כל תקופת מנוי נוספת מאותו סוג, אלא אם בוטל כדין בהתאם להוראות הסכם זה והדין החל.
1.15
מובהר כי יום התחלת השירות אינו תלוי בשימוש בפועל של הלקוח במערכת, בהיקף השימוש שלו, במספר ההתחברויות שלו, או במועד שבו בחר להתחיל לעבוד עם המערכת בפועל.
1.16
פרטי הגישה למערכת נשלחים ללקוח עם ביצוע התשלום, וממועד זה השירות ייחשב כזמין עבורו.
1.17
הלקוח אחראי הבלעדי לעשות שימוש במערכת בפועל לאחר קבלת הגישה אליה, והחברה אינה אחראית לכך שהלקוח לא עשה שימוש במערכת, עשה בה שימוש חלקי, או לא מיצה את אפשרויותיה.
1.18
הלקוח מצהיר כי הוא מתקשר עם החברה לצורך פעילותו העסקית ו/או המקצועית, בין אם הוא פועל כעוסק פטור, עוסק מורשה, חברה בע"מ, שותפות או כל גוף עסקי אחר, וכי השירות נרכש לצרכים עסקיים, מסחריים, מקצועיים או תפעוליים ולא לצריכה פרטית או ביתית.
 
2. אישור ההסכם וההתקשרות
2.1
ביצוע תשלום עבור המערכת, בצירוף משלוח הסכם זה לכתובת הדוא"ל שמסר הלקוח, והעמדת השירות ו/או פרטי הגישה לרשות הלקוח, יהוו אישור, הסכמה והתחייבות מלאה ומחייבת לכל תנאי הסכם זה, אף אם הלקוח טרם התקין את המערכת, טרם התחבר אליה, טרם עשה בה שימוש בפועל או לא השלים כל פעולה נוספת לאחר התשלום.
2.2
הלקוח מצהיר ומאשר כי ביצוע התשלום עבור השירות, בצירוף משלוח הסכם זה לכתובת הדוא"ל שמסר והעמדת השירות ו/או פרטי הגישה לרשותו, יהוו ראיה מספקת לכך שהלקוח קיבל את ההסכם, עיין בו, אישר אותו והסכים לכל תנאיו, גם אם לא התקין את המערכת, לא התחבר אליה ולא עשה בה שימוש בפועל.
2.3
מובהר כי ההסכם יחייב את הלקוח גם אם לא חתם עליו בחתימה ידנית או דיגיטלית, וגם אם לא סימן תיבת אישור אקטיבית, ובלבד שההסכם נשלח אליו לכתובת הדוא"ל שמסר ו/או הועמד לרשותו במסגרת תהליך ההצטרפות, ההתקנה או השימוש.
2.4
הלקוח מוותר על כל טענה שלפיה לא קרא את ההסכם, לא הבין אותו, לא אישר אותו בלחיצה אקטיבית, או לא היה מודע לתנאיו, אם ההסכם נשלח אליו ו/או הועמד לרשותו בסמוך לביצוע התשלום ו/או תחילת השירות.
 
 
2.5
רישומי החברה, מערכות הדיוור, מערכות החיוב, לוגים טכנולוגיים, נתוני התקנה, נתוני התחברות, רישומי CRM, חשבוניות, קבלות, הודעות דוא"ל, הודעות SMS, הודעות מערכת ונתוני שימוש, יהוו ראיה לכאורה לכל עניין הנוגע לשליחת ההסכם, לתחילת השירות, להסכמת הלקוח ולשימוש במערכת.
 
3. השירות המוענק ללקוח ומהות המערכת
3.1
החברה תעניק ללקוח גישה למערכת, הכוללת בין היתר:
3.1.1
האזנה לשיחות בזמן אמת;
3.1.2
זיהוי תוכן שיחה בזמן אמת;
3.1.3
מתן טיפים, רעיונות, תובנות, הכוונה והצעות בזמן אמת;
3.1.4
סיכום שיחה אוטומטי;
3.1.5
יכולות תמלול, עיבוד, ניתוח והסקת מסקנות, ככל שקיימות במערכת מעת לעת.
3.2
המערכת הינה מערכת עזר בלבד ללקוח. המערכת אינה מהווה תחליף לשיקול דעת אנושי, אינה מבטיחה תוצאות מכירה, אינה מבטיחה הצלחה כלשהי, ועלולים ליפול בה שיבושים, באגים, טעויות, חוסרים, אי דיוקים, עיכובים או חוסר התאמה לנסיבות.
3.3
כל מידע, טיפ, רעיון, המלצה, תובנה או הצעה שהמערכת מציגה הינם בגדר הצעה בלבד, והאחריות הסופית על אופן ההתנהלות בשיחה, על האמירות הנאמרות בה, על הפעולות שננקטות בעקבותיהן ועל כל תוצאה עסקית או אחרת, חלה על הלקוח בלבד.
3.4
החברה מעניקה ללקוח רישיון שימוש מוגבל, אישי, חוזר וניתן לביטול בהתאם להוראות הסכם זה, לצורך שימוש פנימי במערכת בלבד, ובכפוף לעמידת הלקוח בכל תנאי ההסכם.
3.5
למען הסר ספק, ההתקשרות אינה מקנה ללקוח כל בעלות במערכת, בקוד, בממשק, בתכנים, בנתונים של החברה, בפיתוחים, בעיצוב, בסימנים המסחריים או בכל זכות קניין רוחני אחרת.
3.6
החברה רשאית לעדכן, לשנות, להרחיב, לצמצם, להשהות או להפסיק פיצ'רים, יכולות, מסכים, רכיבים או חלקים במערכת, לפי שיקול דעתה ובהתאם לצרכים תפעוליים, מסחריים, משפטיים או טכנולוגיים.
 
4. אחריות מקצועית, שיקול דעת הלקוח והסתמכות על המערכת
4.1
הלקוח הוא האחראי הבלעדי לתוכן הדברים הנאמרים במהלך כל שיחה שבה נעשה שימוש במערכת.
4.2
הלקוח יפעיל שיקול דעת עצמאי ולא יסתמך באופן עיוור על המלצות, טיפים, רעיונות, תשובות או תוצרי המערכת.
4.3
ככל שהמערכת מציגה טיפ, רעיון, ניסוח, הצעה או המלצה שאינם מתאימים לנסיבות השיחה, אחריות הלקוח בלבד שלא לאמץ אותם ולפעול בהתאם לשיקול דעתו המקצועי והעצמאי.
4.4
החברה לא תישא בכל אחריות לתוצאות עסקיות, אמירות, פעולות, החלטות, התחייבויות, מצגים או נזקים שנגרמו עקב או בקשר עם שימוש הלקוח במערכת.
4.5
מובהר כי המערכת הינה כלי טכנולוגי המספק המלצות בינה מלאכותית, וכי מטבעה של טכנולוגיה מסוג זה עלולים להיווצר אי דיוקים, טעויות, חוסר התאמה לנסיבות, באגים, שיבושים או חוסר זמינות זמני או קבוע. החברה אינה אחראית לכל נזק או תוצאה הנובעים מהסתמכות על תוצרי המערכת.
4.6
המערכת אינה מבטיחה תוצאות או הצלחה כלשהי.
 
5. מסלולי ההתקשרות, חיובים, טוקנים, חידוש וביטול
5.1
החברה מציעה, נכון למועד הסכם זה, את מסלולי ההתקשרות הבאים:
5.1.1 מסלול חודשי
מנוי חודשי מתחדש, במחיר של 500 ש"ח בתוספת מע"מ כדין לכל חודש.
5.1.2 מסלול רבעוני
מנוי רבעוני מתחדש, במחיר של 1,000 ש"ח בתוספת מע"מ כדין לכל רבעון.
5.1.3 מסלול שנתי
מנוי שנתי מתחדש, במחיר של 3,600 ש"ח בתוספת מע"מ כדין לכל שנה.
5.2
בחירת מסלול על ידי הלקוח מהווה התחייבות מלאה לכל תקופת המסלול שנבחר, וכן לכל תקופת חידוש נוספת של אותו מסלול, כל עוד המנוי לא הסתיים או בוטל כדין ובהתאם להוראות הסכם זה והדין החל.
5.3
הלקוח מאשר כי מדובר במנוי מתחדש אוטומטית, כך שמסלול חודשי יתחדש מדי חודש, מסלול רבעוני יתחדש מדי רבעון, ומסלול שנתי יתחדש מדי שנה, אלא אם הופסק כדין ובהתאם להוראות הסכם זה והדין החל.
5.4
אלא אם החברה אישרה אחרת בכתב, התמורה תחויב מראש, במלואה או בהתאם למנגנון החיוב שהחברה הגדירה במועד ההצטרפות.
5.5
לכל סכום יתווסף מע"מ כדין, בשיעור שיהיה בתוקף במועד החיוב.
5.6
החברה רשאית לעדכן מחירים ביחס להתקשרויות חדשות ו/או תקופות חידוש עתידיות, ובלבד שהעדכון לא יחול רטרואקטיבית על תקופת מנוי שכבר החלה.
 
5.7
הלקוח מודע, מסכים ומאשר כי השימוש במערכת עשוי להיות כרוך בצריכת טוקנים מעבר למחיר המנוי הבסיסי של המסלול שבו בחר.
5.8
תשלומי הטוקנים אינם כלולים במחיר המנוי החודשי, הרבעוני או השנתי, אלא אם החברה ציינה אחרת במפורש ובכתב.
5.9
הלקוח מתחייב לשלם באופן שוטף ומלא כל חיוב בגין צריכת טוקנים, שימוש עודף, שימוש משתנה, קריאות API, הפקת פלטים, פעולות חישוב, פעולות עיבוד, שימוש במודלי בינה מלאכותית, או כל צריכה תפעולית אחרת במערכת, ככל שאלה חלים עליו.
5.10
היקף החיוב בגין טוקנים ייקבע בהתאם להיקף השימוש בפועל של הלקוח, כפי שיימדד, יתועד ויירשם במערכות החברה.
5.11
הלקוח מאשר כי חיובי הטוקנים הם חיובים נפרדים ונוספים על דמי המנוי, וכי הם ישולמו במלואם גם אם הלקוח אינו עושה שימוש מלא בכל ו/אוביתר רכיבי המנוי.
5.12
רישומי החברה יהוו ראיה להיקף צריכת הטוקנים ולגובה החיוב.
5.13
ככל שהחברה תחייב טוקנים לפי מנגנון טעינה מראש, חבילות שימוש, ספי חיוב, מינימום טעינה, מחירון משתנה, חיוב בדולרים, חיוב לפי משתמש או כל מנגנון מסחרי אחר, יחול המנגנון כפי שיוגדר על ידי החברה מעת לעת, והלקוח מתחייב לעמוד בו.
5.14
תקופת ההתחייבות הראשונה תחל ביום התחלת השירות ותימשך לפי המסלול שנבחר על ידי הלקוח.
5.15
בתום כל תקופת מנוי, יתחדש המנוי אוטומטית לתקופה נוספת זהה, אלא אם הלקוח הודיע לחברה בכתב על רצונו לסיים את המנוי לפחות 14 ימי עסקים לפני מועד החידוש.
5.16
מסלול חודשי יתחדש בכל פעם לתקופה נוספת של חודש אחד, אלא אם נמסרה הודעת ביטול בכתב לפחות 14 ימי עסקים לפני מועד החידוש.
5.17
מסלול רבעוני יתחדש בכל פעם לתקופה נוספת של שלושה חודשים, אלא אם נמסרה הודעת ביטול בכתב לפחות 14 ימי עסקים לפני מועד החידוש.
5.18
מסלול שנתי יתחדש בכל פעם לתקופה נוספת של שנים-עשר חודשים, אלא אם נמסרה הודעת ביטול בכתב לפחות 14 ימי עסקים לפני מועד החידוש.
5.19
כל תקופת חידוש תיחשב כתקופת התחייבות חדשה מאותו סוג, והתנאים שחלו על תקופת המנוי הקודמת יחולו גם עליה, אלא אם עודכן אחרת.
 
5.20
הלקוח מצהיר, מאשר ומתחייב כי הצטרפות למסלול מהווה התחייבות לתקופת המסלול שנבחר, וכן מודע לכך שהמנוי מתחדש אוטומטית לתקופות נוספות מאותו סוג, אלא אם בוטל כדין.
5.21
לא יהיה הלקוח רשאי לבטל, לקצר, להקפיא, להשהות או להפסיק את ההתקשרות לפני תום תקופת ההתחייבות הרלוונטית. למעט מקום שבו קיימת ללקוח זכות ביטול או סיום שלא ניתן להתנות עליה לפי דין, יחול האמור לעיל במלואו.
5.22
מבלי לגרוע מהאמור לעיל, במקרה שבו הלקוח יבקש להפסיק את השימוש במערכת, יחדל להשתמש בה בפועל, יסיר אותה, ימנע מהתחברות אליה, יפסיק פעילות עסקית, יסגור את עסקו, יחליף מערכת, או יודיע כי אינו מעוניין עוד בשירות, לא יהיה בכך כדי לגרוע מהתחייבותו המלאה לשלם את מלוא התמורה עבור כל יתרת תקופת ההתחייבות.
5.23
במקרה של הפסקה מוקדמת ביוזמת הלקוח, מכל סיבה שהיא, החברה תהיה רשאית, בכפוף לכל דין, להעמיד לפירעון מיידי את מלוא יתרת התמורה שטרם שולמה עבור תקופת ההתחייבות, וכן כל חיוב בגין טוקנים שנצרכו עד מועד הסיום בפועל.
5.24
סכומים ששולמו לחברה בגין דמי מנוי, תקופת התחייבות או צריכת טוקנים, לא יוחזרו, כולם או חלקם, גם אם הלקוח בחר שלא לעשות שימוש במערכת בפועל.
5.25
מובהר כי אי-שימוש במערכת, שימוש חלקי, חוסר שביעות רצון, שינוי צרכים עסקיים, חוסר כדאיות כלכלית, הפסקת פעילות, קשיי הטמעה, היעדר זמן, או כל טענה דומה אחרת, לא יהוו עילה לביטול מוקדם או להחזר כספי.
5.26
הלקוח מתחייב לשלם את כל הסכומים במלואם ובמועדם.
5.27
הלקוח מאשר לחברה לחייב את אמצעי התשלום שנמסר על ידו בכל סכום המגיע לה לפי הסכם זה, לרבות בגין דמי מנוי, חידושי מנוי, צריכת טוקנים, יתרת תקופת התחייבות, חיובים נלווים, ריבית פיגורים, הצמדה, הוצאות גבייה, הוצאות משפט ושכר טרחת עורך דין, ככל שהדבר מותר לפי דין.
5.28
אי-כיבוד אמצעי תשלום, ביטול הוראת קבע, הכחשת עסקה, ביטול חיוב או כל פעולה דומה מצד הלקוח לא יגרעו מחובתו לשלם את מלוא הסכומים המגיעים לחברה.
5.29
בכל מקרה של פיגור בתשלום, החברה תהיה רשאית, מבלי לגרוע מכל סעד אחר, להשעות גישה למערכת, להגביל שירותים, לפעול לגביית החוב ולדרוש ריבית פיגורים והוצאות גבייה, ככל שהדבר מותר לפי דין.
 
6. חוקיות שימוש, הקלטות, מידע, פרטיות ותכני לקוח
6.1
הלקוח אחראי לוודא כי השימוש במערכת, לרבות האזנה, ניתוח, תמלול, עיבוד שיחות בזמן אמת, שמירת נתונים והפקת תובנות, עומד בכל דרישות הדין החל עליו.
6.2
הלקוח אחראי לוודא כי הוא צד כדין לכל שיחה, הקלטה, האזנה או עיבוד שביחס אליהם מופעלת המערכת, או כי עומדת לו כל הרשאה חוקית אחרת הנדרשת לפי הדין החל.
6.3
החברה אינה מספקת ייעוץ משפטי בכל הנוגע להקלטות, האזנה, פרטיות, הסכמה, דיני עבודה, מאגרי מידע, שימוש בבינה מלאכותית או חוקיות השימוש במערכת, והאחריות לבחינת נושאים אלה מוטלת על הלקוח בלבד.
6.4
כל טענה, דרישה, נזק, תביעה או הליך מצד צד שלישי, רשות או גורם כלשהו, הנוגעים לפרטיות, האזנה, הקלטה, עיבוד מידע, הסכמה, שימוש בנתוני שיחה או כל הפרת דין נטענת הנובעת מאופן השימוש של הלקוח במערכת, יהיו באחריותו הבלעדית של הלקוח.
6.5
החברה לא תישא באחריות לכל טענה של צד שלישי הנוגעת לפרטיות, האזנה, הקלטה, עיבוד מידע או שימוש אסור במערכת על ידי הלקוח.
6.6
הלקוח מודע ומסכים לכך שהפעלת המערכת כרוכה בשימוש במידע ובנתונים שונים, וכי החברה רשאית לשמור, לתעד, להעתיק, לעבד, לנתח, להסיק מסקנות, להפיק תובנות, לבצע עיבוד סטטיסטי, לבצע עיבוד אנליטי, לבצע שימוש מסחרי, עסקי, טכנולוגי או מחקרי, ולהשתמש בכל מידע תפעולי, טכני, חוזי, מסחרי, תוכני, קולי, טקסטואלי, מצרפי או נגזר הנוגע להתקשרות ו/או לשימוש במערכת, לכל שימוש העומד על דעתה של החברה, לרבות לצרכי אספקת השירות, תפעול, אבטחה, שיפור, בקרה, שירות לקוחות, גבייה, אכיפת זכויות, אימון מודלים, פיתוח מוצרים, מסקנות סטטיסטיות, מחקר, מסחור והעברה לצדדים שלישיים, והכל בכפוף לדין החל.
6.7
מבלי לגרוע מהאמור לעיל, החברה תהיה רשאית לעשות שימוש במידע, בתמלולים, בנתונים, בתובנות, במסקנות, בקטגוריזציות, בנתונים מעובדים, בנתונים אנונימיים, בנתונים מצרפיים ובנתונים שנגזרו מהשימוש במערכת, בעצמה או באמצעות צדדים שלישיים, בין אם לצורך אימון מודלים, שיפור מודלים, ניתוחים עסקיים, מחקרים, הפקת תוצרים מסחריים, או כל שימוש אחר שתמצא לנכון, בכפוף לדין החל.
6.8
החברה מתחייבת כי לא תיצור קשר יזום עם הלידים או הלקוחות של הלקוח, ולא תפנה אליהם לצורך הצעה, שיווק או מכירה של שירותים או מוצרים מתחרים לשירותי הלקוח, באמצעות פרטי הקשר המזוהים של הלקוח או של אותם לידים.
6.9
מובהר כי התחייבות זו אינה חלה על שימוש במידע סטטיסטי, אנונימי, מצרפי או נגזר, לרבות תובנות, ניתוחים, מדדים ומסקנות עסקיות המופקים מן השימוש במערכת, ובלבד שלא תתבצע פנייה ישירה ללידים ולא ייעשה שימוש בפרטי קשר מזהים של הלקוח לצורך פעילות מסחרית מול אותם לידים.
6.10
הלקוח מצהיר כי ככל שהוא מזין למערכת מידע של צדדים שלישיים, הוא אחראי הבלעדי לוודא כי עומדות לו כל ההרשאות, ההסכמות והזכויות הנדרשות לפי דין לצורך כך.
6.11
עם סיום ההתקשרות, מכל סיבה שהיא, החברה תהיה רשאית, לפי שיקול דעתה, למחוק, לחסום, לארכב, להפסיק גישה, להוציא משימוש, לשמור בגיבוי או לשמר בכל דרך אחרת מידע, תמלולים, קבצים, תוצרים, נתוני שימוש, תיעוד, לוגים, נתוני מערכת ונתונים אחרים הקשורים ללקוח.
 
 
6.12
החברה אינה מתחייבת לשמור מידע לתקופה כלשהי לאחר סיום ההתקשרות, ואינה מחויבת לאפשר ללקוח גישה למידע לאחר סיומה, אלא אם התחייבה לכך במפורש ובכתב.
6.13
מבלי לגרוע מהאמור, החברה תהיה רשאית להמשיך לשמור ולהשתמש גם לאחר סיום ההתקשרות בנתונים אנונימיים, נתונים מצרפיים, נתונים סטטיסטיים, תובנות, מסקנות, מדדים, נתונים נגזרים, לוגים טכניים, נתוני אבטחה ונתונים הנדרשים לצרכים משפטיים, רגולטוריים, תפעוליים, מסחריים, ראייתיים, אבטחתיים, גיבוי, אכיפת זכויות, שיפור שירותים, אימון מודלים ופיתוח מוצרים, והכל בכפוף לדין החל.
6.14
הלקוח אחראי הבלעדי לבצע, לפני סיום ההתקשרות, כל גיבוי, ייצוא, שמירה, הורדה או העתקה של מידע שהוא מבקש לשמר, והחברה לא תישא באחריות לכל אובדן מידע, אי-יכולת לשחזרו או מחיקתו לאחר סיום ההתקשרות. החברה אינה מתחייבת לספק ללקוח נתונים להורדה או להעברה וכל מידע שימסר הינו על פי שיקול דעתה הבלעדי של החברה.
6.15
הלקוח מעניק לחברה, למשך תקופת ההתקשרות ולאחריה ככל שנדרש לפי הסכם זה ולפי הדין החל, רישיון בלתי בלעדי, כלל-עולמי, ללא תמורה נוספת, להשתמש בכל מידע, תוכן, קובץ, טקסט, שמע, תמלול, קלט, הנחיה, מסמך, נתון, פלט ותוכן אחר שהלקוח מוסר, מזין, מעלה, משדר או יוצר באמצעות המערכת, לצורך אספקת השירות, תפעולו, שיפורו, אבטחתו, תחזוקתו, פיתוחו, ניתוחו, בקרתו, תמיכתו, גביית תשלומים, אכיפת זכויות, אימון מודלים ופיתוח מוצרים וכל צורך נוסף על פי שיקול דעת החברה, והכל בכפוף לדין החל.
6.16
הלקוח מצהיר ומתחייב כי הוא מחזיק בכל הזכויות, ההרשאות, ההסכמות והבסיסים המשפטיים הנדרשים לצורך מסירת המידע לחברה ולצורך השימושים המפורטים בהסכם זה.
6.17
הלקוח יישא באחריות בלעדית לכל טענה של צד שלישי שלפיה לא הייתה לו הזכות למסור מידע, תוכן, תמלול, הקלטה, נתון או חומר אחר למערכת או לחברה.
 
7. תפעול המערכת, תשתיות, אבטחה וזמינות
7.1
החברה רשאית להשתמש, לפי שיקול דעתה הבלעדי, בספקי משנה, קבלני משנה, ספקי ענן, ספקי אחסון, ספקי תמלול, ספקי בינה מלאכותית, ספקי אבטחה, ספקי API, ספקי ניתוח, ספקי גיבוי וכל ספק טכנולוגי אחר, בארץ או מחוצה לה, ללא כל הגבלה.
7.2
הלקוח מאשר מראש מסירה, העברה, אחסון, עיבוד, ניתוח ושימוש במידע אצל ספקי משנה כאמור.
7.3
המידע עשוי להישלח, להישמר, להיעבד או להיות נגיש בשרתים ו/או מערכות מחוץ לישראל, בהתאם לתפעול המערכת, תשתיות הענן, כלי הבינה המלאכותית, כלי העיבוד או כל תשתית טכנולוגית אחרת המשמשת את החברה או את ספקיה.
7.4
החברה מפעילה אמצעי אבטחה סבירים, לרבות סיסמאות, מנגנוני גישה, בקרות מערכת ואמצעים טכנולוגיים כפי שתמצא לנכון מעת לעת.
 
 
7.5
החברה לא תהיה אחראית לאירועי תקיפה, פריצה, חדירה, דליפה, חשיפה, גישה בלתי מורשית, אובדן מידע, שיבוש מידע, תקיפת סייבר או כל אירוע אבטחה אחר.
7.6
הלקוח מאשר כי אין באפשרות החברה להבטיח אבטחה מוחלטת מפני פריצות, תקיפות סייבר, חשיפות מידע, כשלים טכנולוגיים או אירועי אבטחה אחרים, וכי החברה לא תישא באחריות לכל נזק, ישיר או עקיף, העלול להיגרם עקב אירועים כאמור, למעט אם הדין קובע אחרת במפורש.
7.7
החברה רשאית לבצע מעת לעת עבודות תחזוקה, תיקונים, שדרוגים, עדכוני גרסה, שינויים בתשתיות, שינויים בממשקים, פעולות גיבוי, פעולות אבטחה, בדיקות מערכת, השבתות יזומות או כל פעולה טכנולוגית או תפעולית אחרת בקשר למערכת, לפי שיקול דעתה.
7.8
הלקוח מאשר כי פעולות כאמור עשויות לגרום, בין היתר, להאטה, הפרעה, אי-זמינות זמנית, שיבוש, השבתה חלקית או מלאה, פגיעה זמנית בפונקציונליות מסוימת, או צורך בהתחברות מחדש, עדכון הרשאות, שינוי תצורה או כל התאמה אחרת.
7.9
ביצוע תחזוקה, השבתה יזומה, שדרוג, עדכון, שינוי תשתיתי או כל פעולה כאמור לא ייחשבו כהפרת הסכם מצד החברה, ולא יקנו ללקוח זכות לכל החזר, קיזוז, פיצוי, ביטול או טענה אחרת, והכל בכפוף לדין החל.
7.10
החברה לא תישא באחריות לכל עיכוב, הפרעה, שיבוש, השבתה, אי-זמינות, ירידה בביצועים, אובדן מידע, פגיעה בפונקציונליות או אי-יכולת לספק את השירות, כולם או חלקם, עקב נסיבות שאינן בשליטתה הסבירה, לרבות כוח עליון.
7.11
לעניין סעיף זה, "כוח עליון" ו/או נסיבות שאינן בשליטת החברה יכללו, בין היתר, מלחמה, פעולות איבה, מצב חירום, גיוס מילואים נרחב, שביתה, השבתה, מהומות, אסון טבע, שריפה, הצפה, מגפה, תקלה בתשתיות אינטרנט, תקלה בחשמל, תקלה אצל ספק ענן, ספק תקשורת, ספק טלפוניה, ספק תמלול, ספק API, ספק בינה מלאכותית, ספק אבטחה, ספק תשתית, חסימה רגולטורית, צו רשות, מתקפת סייבר, חדירה, כשל תפעולי חיצוני, או כל אירוע אחר שאינו בשליטת החברה.
7.12
בכל מקרה כאמור, החברה תהיה רשאית לדחות, להשעות, לצמצם, לשנות או להפסיק זמנית את השירות, כולו או חלקו, מבלי שהדבר ייחשב כהפרה מצד החברה ומבלי שהלקוח יהיה זכאי לכל סעד, החזר או פיצוי, והכל בכפוף לדין החל.
7.13
הלקוח מאשר כי המערכת נשענת, כולה או חלקה, על שירותים, תשתיות, ממשקים, תוכנות, ספקי ענן, ספקי API, ספקי בינה מלאכותית, ספקי תמלול, ספקי תקשורת, ספקי טלפוניה, ספקי אחסון, ספקי אבטחה וספקים חיצוניים נוספים.
7.14
החברה אינה אחראית לכל שינוי, תקלה, הגבלה, חסימה, השבתה, ביטול שירות, שינוי מחירים, שינוי מדיניות, ירידה באיכות, עיכוב, חוסר תאימות, אובדן פונקציונליות או כל פגיעה אחרת שמקורה אצל גורם צד שלישי כאמור.
 
 
7.15
מבלי לגרוע מהאמור, החברה תהיה רשאית להתאים את המערכת, לשנות רכיבים בה, להחליף ספקים, לצמצם פונקציות, לשנות מנגנוני חיבור, לשנות יכולות או להפסיק יכולת מסוימת, כולה או חלקה, אם הדבר נובע ממגבלה, שינוי או דרישה של ספק צד שלישי או מתלות טכנולוגית בו.
 
7.16
אירוע הנובע, במישרין או בעקיפין, מספק צד שלישי לא ייחשב כהפרת הסכם מצד החברה, ולא יקנה ללקוח זכות להחזר, פיצוי, קיזוז, ביטול או כל סעד אחר, והכל בכפוף לדין החל.
7.17
המערכת והשירותים הניתנים במסגרתה מסופקים כפי שהם (AS IS) ובכפוף לזמינותם (AS AVAILABLE).
7.18
החברה אינה מתחייבת לרמת שירות מסוימת, לזמינות רציפה, לזמן תגובה מסוים, לזמן תיקון תקלות, להיקף פעילות מובטח, לרציפות מלאה, או לכך שהמערכת תפעל ללא הפרעה, השבתה, עיכוב, שיבוש או תקלה.
7.19
אלא אם החברה התחייבה במפורש ובכתב למסמך שירות נפרד, לא יחול על ההתקשרות כל SLA, רמת שירות מוסכמת או התחייבות תפעולית מיוחדת.
 
8. שימוש מותר ואסור, סודיות, קניין רוחני ואי-עקיפה
8.1
הלקוח מתחייב לשמור בסודיות מלאה כל מידע טכנולוגי, עסקי, מסחרי, מקצועי, תפעולי או אחר של החברה הנוגע למערכת, למבנה שלה, לאופן פעולתה, למנגנוניה, לתמחור שלה, לפיתוחיה, לרכיביה או לכל מידע שאינו פומבי בקשר אליה.
8.2
על אף האמור, ללקוח מותר לשתף פלטים, תשובות, תוצרים ותוכן שנוצרו עבורו על ידי המערכת, לרבות צילומי מסך של התוצרים בלבד, ובלבד שאין בכך כדי לחשוף מידע סודי של החברה, לוגיקה פנימית, מנגנוני עבודה, מידע טכנולוגי מוגן או חלקים מהמערכת עצמה.
8.3
אסור ללקוח לבצע הנדסה לאחור, פירוק, דה-קומפילציה, חיקוי, ניתוח, העתקה או כל ניסיון ללמוד, לחשוף או לשחזר את מנגנוני המערכת.
8.4
חובת הסודיות לפי סעיף זה אינה מוגבלת בזמן.
8.5
כל הפרה של סעיף זה תיחשב כהפרה יסודית של ההסכם.
8.6
הלקוח מתחייב לעשות שימוש חוקי, תקין, סביר ובהתאם להוראות החברה.
8.7
הלקוח לא יהיה רשאי:
8.7.1
להעתיק, לשכפל, להפיץ, למכור, להשכיר, להמחות, להעמיד לרשות הציבור או למסחר את המערכת;
8.7.2
לבצע הנדסה לאחור, פירוק, דה-קומפילציה או ניסיון לחשיפת קוד המקור;
8.7.3
לעקוף מנגנוני אבטחה, רישוי או הגבלת שימוש;
8.7.4
להשתמש במערכת בניגוד לדין או באופן שפוגע בזכויות צדדים שלישיים;
8.7.5
לאפשר שימוש במערכת לצד שלישי ללא אישור מפורש מהחברה.
8.8
כל הזכויות במערכת, לרבות זכויות יוצרים, סימני מסחר, פטנטים, סודות מסחריים, קוד, עיצוב, ממשקים, מסכים, תיעוד, מודלים, פיתוחים, נתונים ותוצרים, שייכות לחברה בלבד או לצדדים שלישיים שהרשו לה להשתמש בהם.
8.9
אין בהסכם זה כדי להקנות ללקוח זכות כלשהי מלבד זכות שימוש מוגבלת בהתאם לתנאי הסכם זה.
8.10
הלקוח מתחייב שלא לפעול, במישרין או בעקיפין, לצורך העתקת המערכת, חיקויה, פיתוח מערכת מתחרה המבוססת מהותית על המערכת, עקיפת מנגנוניה, או שימוש במידע, בתובנות, במבנה, בלוגיקה, בתוצרים או בדרך פעולתה של המערכת לצורך הקמה, פיתוח, שיווק או הפעלה של שירות מתחרה.
8.11
הלקוח מתחייב שלא לשדל, לגייס, להעסיק, להתקשר או לנסות להתקשר עם מי מעובדי החברה, ספקיה, מפתחיה או קבלניה, לצורך קבלת מידע סודי, עקיפת החברה, פיתוח מערכת מתחרה או קבלת שירות זהה או דומה מחוץ למסגרת ההתקשרות עם החברה, במהלך תקופת ההתקשרות ובמשך 12 חודשים לאחר סיומה.
8.12
מבלי לגרוע מהאמור, אין בסעיף זה כדי למנוע מן הלקוח להשתמש בשירותים, פתרונות, תוכנות או מערכות אחרות הקיימות בשוק באופן עצמאי, ובלבד שלא יעשה שימוש במידע סודי של החברה, לא יעתיק את המערכת ולא יפעל בניגוד להוראות הסכם זה.
 
9. הגבלת אחריות, שיפוי, מצגים חיצוניים והסתמכות
9.1
אחריות החברה מוגבלת לגובה התשלום החודשי הקבוע האחרון ששילם הלקוח בפועל לחברה בלבד.
9.2
החברה לא תישא באחריות לנזקי רווחים, אובדן מכירות, אובדן הכנסות, אובדן לקוחות, אובדן נתונים, פגיעה במוניטין, טעויות בינה מלאכותית, חוסר דיוק, באגים במערכת המונעים שימוש באופן זמני, שיבושים, חוסר זמינות, עיכובים, תוצאות עסקיות או כל נזק עקיף, תוצאתי, מיוחד או אחר, הנובע משימוש או מאי-יכולת להשתמש במערכת.
9.3
הלקוח ישפה ויפצה את החברה, עובדיה, מנהליה, בעלי מניותיה, קבלניה ומי מטעמה, מיד עם דרישתם הראשונה, בגין כל נזק, הוצאה, תשלום, הפסד, קנס, חיוב, עלות, תביעה או דרישה, לרבות שכר טרחת עורכי דין, שינבעו מהפרת דין, שימוש אסור, שימוש בלתי חוקי במערכת, הפרת ההסכם, הפרת פרטיות, הפרת זכויות צד שלישי או הסתמכות שגויה על המערכת.
 
9.4
הלקוח מאשר כי התקשרותו בהסכם זה אינה מבוססת על כל מצג, התחייבות, הבטחה, פרסום, הדגמה, מצגת, שיחה, תכתובת, הודעת ווטסאפ, שיחת מכירה, חומר שיווקי, הקלטת מכירה, מידע בעל פה או כל אמירה אחרת שלא נכללו במפורש ובכתב בהסכם זה או במסמך מסחרי חתום ומאושר במפורש על ידי החברה.
9.5
למען הסר ספק, כל תיאור שיווקי, הדגמה, שיחת מכירה, מצגת, סרטון, דף נחיתה, הודעה מוקלטת, מענה של נציג, דברי איש מכירות, או כל הסבר אחר שנמסרו ללקוח לפני ההתקשרות, נועדו למטרות המחשה כללית בלבד, ואינם מהווים התחייבות חוזית מחייבת מצד החברה אלא אם נכללו במפורש בהסכם זה או באישור כתוב ומפורש של החברה.
9.6
הלקוח מצהיר כי לא הסתמך על כל אמירה של נציג, עובד, משווק, מפרסם, שותף, ספק או גורם אחר מטעם החברה, אלא רק על האמור במפורש בהסכם זה ובמסמך מסחרי כתוב שאושר במפורש על ידי החברה.
9.7
במקרה של סתירה בין האמור בהסכם זה לבין כל מצג, תכתובת, הודעה, פרסום, שיחה או מסמך אחר, יגברו הוראות הסכם זה, אלא אם החברה אישרה אחרת במפורש ובכתב.
 
10. השעיה, חסימה וסיום על ידי החברה
10.1
החברה רשאית, לפי שיקול דעתה, להשעות, להגביל או לחסום את גישת הלקוח למערכת, באופן זמני או קבוע, בכל אחד מהמקרים הבאים:
10.1.1
הפרת הוראה מהוראות הסכם זה;
10.1.2
אי-תשלום במועד, לרבות בגין דמי מנוי או צריכת טוקנים;
10.1.3
שימוש אסור, בלתי חוקי או מסכן;
10.1.4
פגיעה במערכת, בחברה, במשתמשים אחרים או בצדדים שלישיים;
10.1.5
חשש להונאה, גניבה, הטעיה, ניצול לרעה או סיכון משפטי או טכנולוגי.
10.2
השעיה או חסימה לפי סעיף זה לא ייחשבו כהפרה מצד החברה, ולא יקנו ללקוח זכות להחזר כספי או לפטור מתשלום עבור תקופת ההתחייבות או צריכת הטוקנים, בכפוף לכל דין.
10.3
במקרה של הפרה יסודית מצד הלקוח, החברה תהיה רשאית להביא את ההסכם לסיומו המיידי, מבלי לגרוע מזכותה לקבל את מלוא הסכומים המגיעים לה עד תום תקופת ההתחייבות ו/או בגין שימוש שנעשה בפועל.
11. הודעות, מסמכים מחייבים, סדר קדימויות, דין ושיפוט
11.1
הודעות יישלחו בדוא"ל וייחשבו כנמסרו בתוך 24 שעות ממועד שליחתן.
11.2
מבלי לגרוע מהאמור, כל הודעה, מסמך, עדכון, דרישה, התראה, חשבונית, קבלה או הסכם שיישלחו לכתובת הדוא"ל שמסר הלקוח, ייחשבו כאילו נמסרו לו כדין.
11.3
חובת הלקוח היא לוודא כי פרטי הקשר שמסר נכונים, תקפים ומעודכנים, ולעדכן את החברה בכל שינוי ללא דיחוי.
11.4
אי-קריאת דוא"ל, סינון הודעה כדואר זבל, החלפת כתובת ללא עדכון, או התעלמות מהודעה שנשלחה לכתובת שנמסרה, לא יפגעו בתוקפה של ההודעה.
11.5
כל הודעת ביטול, סיום התקשרות, בקשה להפסקת חידוש מנוי או כל הודעה מהותית אחרת מצד הלקוח לפי הסכם זה, תישלח אך ורק לכתובת הדוא"ל: support@closer-live.com.
11.6
הודעת ביטול או סיום שלא נשלחה לכתובת הדוא"ל האמורה לא תיחשב כהודעה שנמסרה כדין, ולא יהיה בה כדי לעצור חידוש מנוי, חיוב, או כל חובה אחרת של הלקוח לפי הסכם זה.
11.7
למען הסר ספק, על מנת למנוע את חידוש המנוי, הודעת ביטול או בקשה להפסקת חידוש תישלח לכתובת support@closer-live.com ותימסר בהתאם ללוחות הזמנים הקבועים בסעיף 5 לעיל. הודעה כאמור תיחשב ככזו שהתקבלה רק אם התקבלה בפועל במערכות החברה ואפשרה לחברה לזהות באופן סביר את הלקוח ואת המנוי שלגביו נשלחה ההודעה.
11.8
מבלי לגרוע מכל זכות של החברה, הלקוח מתחייב כי לפני נקיטת כל הליך משפטי, דרישה כספית, בקשה לסעד זמני או טענה להפרת ההסכם, ימסור לחברה הודעה בכתב ומפורטת לכתובת support@closer-live.com, ויאפשר לחברה תקופה של 14 ימים לפחות לבדוק את הטענה ולנסות לתקנה, ככל שהדבר אפשרי בנסיבות העניין.
11.9
אין באמור כדי לגרוע מזכותה של החברה לנקוט בכל הליך, סעד או פעולה לפי דין או לפי הסכם זה, בכל עת.
11.10
הסכם זה כפוף לדין הישראלי בלבד.
11.11
סמכות השיפוט המקומית הייחודית בכל מחלוקת הנוגעת להסכם זה תהיה נתונה לבתי המשפט המוסמכים במחוז תל אביב בלבד.
 
12. שונות
12.1
החברה רשאית לעדכן את נוסח ההסכם מעת לעת.
 
 
12.2
נוסח מעודכן יחול ממועד פרסומו ו/או שליחתו ללקוח ו/או העמדתו לרשותו במערכת, לגבי המשך שימוש עתידי, בכפוף לדין החל.
.312
הלקוח לא יהיה רשאי להמחות, להעביר, להסב או לשעבד את זכויותיו או חובותיו לפי הסכם זה, כולן או חלקן, ללא אישור החברה מראש ובכתב.
.412
החברה תהיה רשאית להמחות, להעביר, להסב או לשעבד את זכויותיה לפי הסכם זה, כולן או חלקן, לפי שיקול דעתה, ובלבד שלא תיפגענה זכויות קוגנטיות של הלקוח לפי דין.
12.5
אי-מימוש זכות מזכויות החברה לפי הסכם זה לא ייחשב כוויתור עליה.
12.6
אם ייקבע כי הוראה מהוראות הסכם זה אינה חוקית, בטלה או בלתי אכיפה, לא יהיה בכך כדי לפגוע ביתר הוראות ההסכם, אשר ימשיכו לעמוד בתוקפן ככל הניתן.
12.7
הסכם זה ממצה את כלל ההבנות בין הצדדים בכל הנוגע לנושא ההתקשרות, וגובר על כל מצג, שיחה, התכתבות, טיוטה או הבנה קודמים, אלא אם נקבע אחרת בכתב ובמפורש.
12.8
כותרות הסעיפים נועדו לנוחות בלבד ולא ישמשו לצורך פרשנות.`;
